import { IGeoTags } from 'shared/types/tags';
import { EGeoType } from '../../../shared/repositories/geo-temp-layer/entities/address_tag/AddressNodeSchema';
import { IDirection, TUndergroundsUnderConstruction } from 'shared/types/geo';
import { TVillage } from 'shared/types/village';
import { IV1GeoTagsResponse } from 'shared/repositories/geo-temp-layer/entities/get_geo_tags/V1GeoTagsResponse';

interface IGeoTagsMeta {
  undergroundsUnderConstruction: TUndergroundsUnderConstruction;
  directions: IDirection[];
  village: TVillage | null;
}

export function prepareGeoTags(
  { geoTags }: IV1GeoTagsResponse,
  { undergroundsUnderConstruction, directions }: IGeoTagsMeta,
): IGeoTags {
  const tags = {} as IGeoTags;

  if (geoTags.newobjectTags.length) {
    tags.newbuildings = geoTags.newobjectTags.reduce<{ [key: number]: string }>(
      (result, tag) => ({ ...result, [Number(tag.id)]: `ЖК «${tag.text}»` }),
      {},
    );
  }

  if (geoTags.newbuildingBuildersTags.length) {
    tags.developers = geoTags.newbuildingBuildersTags.reduce<{ [key: number]: string }>(
      (result, tag) => ({ ...result, [Number(tag.id)]: tag.text }),
      {},
    );
  }

  if (geoTags.addressTags.length) {
    geoTags.addressTags.forEach(addressTag => {
      const tag = { [Number(addressTag.addressNodes[0].id)]: addressTag.text };

      if (addressTag.addressNodes[0].geoType === EGeoType.Location) {
        tags.locations = { ...(tags.locations || {}), ...tag };
      } else if (addressTag.addressNodes[0].geoType === EGeoType.Street) {
        tags.streets = { ...(tags.streets || {}), ...tag };
      } else if (addressTag.addressNodes[0].geoType === EGeoType.House) {
        tags.houses = { ...(tags.houses || {}), ...tag };
      }
    });
  }

  if (geoTags.districtTags.length) {
    tags.districts = geoTags.districtTags.reduce<{ [key: number]: string }>(
      (result, tag) => ({ ...result, [Number(tag.id)]: tag.text }),
      {},
    );
  }

  if (geoTags.metroTags.length) {
    tags.undergrounds = geoTags.metroTags.reduce<{
      [key: number]: { name: string; color?: string; releaseYear?: number };
    }>(
      (result, tag) => ({
        ...result,
        [Number(tag.id)]: {
          name: tag.text,
          color: tag.color || undefined,
          releaseYear: undergroundsUnderConstruction[tag.id],
        },
      }),
      {},
    );
  }

  if (geoTags.railwayTags.length) {
    tags.railways = geoTags.railwayTags.reduce<{ [key: number]: string }>(
      (result, tag) => ({ ...result, [Number(tag.id)]: tag.text }),
      {},
    );
  }

  if (geoTags.regionalDistrictTags.length) {
    tags.regionalDistricts = geoTags.regionalDistrictTags.reduce<{ [key: number]: string }>(
      (result, tag) => ({ ...result, [Number(tag.id)]: tag.name }),
      {},
    );
  }

  if (directions.length) {
    tags.directions = directions;
  }

  if (geoTags.villageTags.length) {
    tags.village = geoTags.villageTags.reduce<{ [key: number]: string }>(
      (result, tag) => ({ ...result, [Number(tag.id)]: tag.text }),
      {},
    );
  }

  if (geoTags.bsCenterTags?.length) {
    tags.bsCenter = geoTags.bsCenterTags.reduce<{ [key: number]: string }>(
      (result, tag) => ({ ...result, [Number(tag.id)]: tag.name }),
      {},
    );
  }

  return tags;
}
